import { maxImageZoom, premadeKit } from "@brickme/project-core/src";
import { maxLayoutDimension } from "~/features/editor/layout-permutations.ts";

const maxResolution =
	premadeKit.basePlateSize * maxLayoutDimension * maxImageZoom;

export { maxResolution };
